import { FC } from "react";
import { IShopNameCellProps } from "../../../interfaces/Fleet/IShopNameCellProps";
import "./ShopNameCell.css";

const ShopNameCell: FC<IShopNameCellProps> = ({ value, row, handleClick }) => {
  const onClick = () => {
    handleClick({
      shopName: row.shopName,
      streetAddress: row.streetAddress,
      state: row.state,
      city: row.city,
      zipCode: row.zipCode,
      phoneNumber: row.phoneNumber,
    });
  };

  return (
    <span onClick={onClick} className="shop-name-cell">
      {value}
    </span>
  );
};

export default ShopNameCell;
